<template>
  <b-form-group label-for="operator-input">
    <div class="search-input-wrapper">
      <b-form-input
        v-model="searchQuery"
        placeholder="Search operator..."
        class="mb-2"
      />
      <button
        v-if="searchQuery"
        class="clear-button"
        @click="clearSearch"
        type="button"
      >
        ✕
      </button>
    </div>
    <div
      class="operator-radio-group"
      :class="{ 'min-height-scroll': useScroll }"
    >
      <template v-if="isSinglePartner">
        <div
          v-for="operator in firstPartnerOperators"
          :key="operator.id"
          class="custom-control custom-radio"
        >
          <input
            type="radio"
            class="custom-control-input"
            v-model="selectedOperatorValue"
            :value="operator.id"
            :id="'operator-' + operator.id"
            :disabled="disabled"
            @change="onChange"
          />
          <label
            class="custom-control-label"
            :for="'operator-' + operator.id"
            >{{ operator.name }}</label
          >
        </div>
      </template>
      <template v-else>
        <template v-if="Array.isArray(filteredOperators)">
          <div v-for="(partner, index) in filteredOperators" :key="index">
            <label v-if="partner.operators.length"
              ><strong>{{ partner.partner }}</strong></label
            >
            <div
              v-for="operator in partner.operators"
              :key="operator.id"
              class="custom-control custom-radio"
            >
              <input
                type="radio"
                class="custom-control-input"
                v-model="selectedOperatorValue"
                :value="operator.id"
                :id="'operator-' + operator.id"
                :disabled="disabled"
                @change="onChange"
              />
              <label
                class="custom-control-label"
                :for="'operator-' + operator.id"
                >{{ operator.name }}</label
              >
            </div>
          </div>
        </template>
        <template v-else>
          <div
            v-for="(partner, partnerId) in filteredOperators"
            :key="partnerId"
          >
            <label v-if="partner.operators.length"
              ><strong>{{ partner.partner }}</strong></label
            >
            <div
              v-for="operator in partner.operators"
              :key="operator.id"
              class="custom-control custom-radio"
            >
              <input
                type="radio"
                class="custom-control-input"
                v-model="selectedOperatorValue"
                :value="operator.id"
                :id="'operator-' + operator.id"
                :disabled="disabled"
                @change="onChange"
              />
              <label
                class="custom-control-label"
                :for="'operator-' + operator.id"
                >{{ operator.name }}</label
              >
            </div>
          </div>
        </template>
      </template>
    </div>
    <template #label>
      <label> <RouteIcon operators /> Operator: </label>
    </template>
  </b-form-group>
</template>

<script>
import RouteIcon from '../RouteIcon'

export default {
  name: 'OperatorSelector',
  components: {
    RouteIcon
  },
  props: {
    operators: {
      type: [Object, Array],
      required: true
    },
    value: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    useScroll: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      searchQuery: ''
    }
  },
  computed: {
    selectedOperatorValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    isSinglePartner() {
      if (Array.isArray(this.filteredOperators)) {
        return this.filteredOperators.length === 1
      }
      return Object.keys(this.filteredOperators).length === 1
    },
    firstPartnerOperators() {
      if (!this.isSinglePartner) return []
      if (Array.isArray(this.filteredOperators)) {
        const firstPartner = this.filteredOperators[0]
        return firstPartner ? firstPartner.operators : []
      }
      const firstPartner = Object.values(this.filteredOperators)[0]
      return firstPartner ? firstPartner.operators : []
    },
    filteredOperators() {
      if (!this.searchQuery) return this.operators

      const searchLower = this.searchQuery.toLowerCase()

      // Если operators - массив
      if (Array.isArray(this.operators)) {
        const filtered = []
        this.operators.forEach(item => {
          if (
            item.partner.toLowerCase().includes(searchLower) ||
            item.operators.some(op =>
              op.name.toLowerCase().includes(searchLower)
            )
          ) {
            const filteredOperators = item.operators.filter(operator =>
              operator.name.toLowerCase().includes(searchLower)
            )

            if (filteredOperators.length > 0) {
              filtered.push({
                ...item,
                operators: filteredOperators
              })
            }
          }
        })
        return filtered
      }

      // Если operators - объект
      const filtered = {}

      Object.entries(this.operators).forEach(([partnerId, partner]) => {
        const filteredOperators = partner.operators.filter(operator =>
          operator.name.toLowerCase().includes(searchLower)
        )

        if (filteredOperators.length > 0) {
          filtered[partnerId] = {
            partner: partner.partner,
            operators: filteredOperators
          }
        }
      })

      return filtered
    }
  },
  methods: {
    onChange() {
      this.$emit('change')
    },
    clearSearch() {
      this.searchQuery = ''
    }
  }
}
</script>

<style scoped>
.operator-radio-group {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #f9f9f9;
}

.operator-radio-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.custom-control {
  margin-bottom: 10px;
}

.custom-control-input:checked ~ .custom-control-label::before {
  background-color: #007bff;
  border-color: #007bff;
}

.custom-control-label {
  cursor: pointer;
}

.min-height-scroll {
  max-height: 300px;
  min-height: 300px;
  overflow-y: scroll;
}

.form-control {
  margin-bottom: 10px;
}

.search-input-wrapper {
  position: relative;
}

.clear-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 0 5px;
  font-size: 14px;
}

.clear-button:hover {
  color: #666;
}

.clear-button:focus {
  outline: none;
}
</style>
